'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = require('reselect');

var _popupOpenSelector = require('../../../../components/popupPanel/popupOpenSelector');

var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUnreadMessageCount = function getUnreadMessageCount(state) {
    return state.getIn(['app', 'analytics', 'unreadMessageCount']);
};

exports.default = (0, _reselect.createStructuredSelector)({
    popupOpen: (0, _popupOpenSelector2.default)('help'),
    unreadMessageCount: getUnreadMessageCount
});


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/help/helpUtilSelector.js
// module id = 779
// module chunks = 0